import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingOverlay } from '../../components';
import { getActiveAnnouncements } from '../../services/firestoreService';
import { formatDateTime } from '../../utils/helpers';
import './NotificationsScreen.css';

export const NotificationsScreen = () => {
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAnnouncements();
    }, []);

    const loadAnnouncements = async () => {
        try {
            const data = await getActiveAnnouncements();
            setAnnouncements(data);
        } catch (error) {
            console.error('Error loading announcements:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingOverlay visible message="Loading announcements..." />;
    }

    return (
        <div className="notifications-screen-modern">
            <div className="notif-header-nav">
                <button className="back-btn-notif" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="notif-title-nav">NOTIFICATIONS</h1>
            </div>

            <div className="notif-content-area">
                {announcements.length > 0 ? (
                    <div className="notif-list-container">
                        {announcements.map((announcement) => (
                            <div key={announcement.id} className="notif-premium-card">
                                <div className="notif-icon-circle">
                                    <span className="material-icons">notifications_active</span>
                                </div>
                                <div className="notif-main-content">
                                    <div className="notif-card-header">
                                        <h4 className="notif-card-title">{announcement.title}</h4>
                                        <span className="notif-card-date">
                                            {formatDateTime(announcement.createdAt)}
                                        </span>
                                    </div>
                                    <p className="notif-card-message">{announcement.message}</p>
                                    <div className="notif-card-footer">
                                        <span className="notif-official-tag">OFFICIAL NOTICE</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="notif-empty-state">
                        <div className="empty-notif-box">
                            <span className="material-icons">notifications_off</span>
                        </div>
                        <h3>ALL CAUGHT UP</h3>
                        <p>THERE ARE NO NEW ANNOUNCEMENTS AT THE MOMENT.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationsScreen;
